import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';
import {
  CancelTicketProps,
  EditTicketProps,
  UpdateARProps,
  UpdateInteractionHistoryProps,
  UpdateShippingProps
} from '@routes/b2b/tickets/shared/ticket-update.model';

@Injectable({
  providedIn: 'root'
})
export class B2bTicketBackendServer extends BaseBackend {

  getTickets(builder): Observable<any> {
    return this.get('/b2b-tickets', { params: builder });
  }

  exportTickets(builder): Observable<any> {
    return this.get('/b2b-tickets/export', { params: builder });
  }

  getStatusSummary(builder): Observable<any> {
    return this.get('/b2b-tickets/status-summary', { params: builder });
  }

  getStateSummary(builder): Observable<any> {
    return this.get('/b2b-tickets/state-summary', { params: builder });
  }

  getTicket(ticketNo): Observable<any> {
    return this.get(`/b2b-tickets/${ ticketNo }`);
  }

  updateTicketSync(ticketNo): Observable<any> {
    return this.get(`/b2b-tickets/${ ticketNo }/sync`);
  }

  updateTicketSyncWithPartnerCall(ticketNo): Observable<any> {
    return this.get(`/b2b-tickets/${ ticketNo }/sync?callPartnerApi=true&forceCall=true`);
  }

  getArGood(partnerOrganization, modelCode): Observable<any> {
    return this.get(`/b2b-tickets/ar-good/${ partnerOrganization }/${ modelCode }`);
  }

  updateTicket(data: EditTicketProps): Observable<any> {
    return this.patch(`/b2b-tickets/${ data.ticketNo }`, data);
  }

  updateShipping(data: UpdateShippingProps): Observable<any> {
    return this.patch(`/b2b-tickets/${ data.ticketNo }/update-shipping`, data);
  }

  cancelTicket(data: CancelTicketProps): Observable<any> {
    return this.patch(`/b2b-tickets/${ data.ticketNo }/cancel`, data);
  }

  updateAR(data: UpdateARProps): Observable<any> {
    return this.patch(`/b2b-tickets/${ data.ticketNo }/update-ar`, data);
  }

  updateRmaNo(data): Observable<any> {
    return this.patch(`/b2b-tickets/${ data.ticketNo }/update-rma-no`, data);
  }

  updateSerialNo(data): Observable<any> {
    return this.patch(`/b2b-tickets/${ data.ticketNo }/update-serial-no`, data);
  }

  updateSubStatus(data): Observable<any> {
    return this.patch(`/b2b-tickets/${ data.ticketNo }/sub-status`, data);
  }

  updateReturnSubStatus(data): Observable<any> {
    return this.patch(`/b2b-tickets/${ data.ticketNo }/return-sub-status`, data);
  }

  updateAgentComment(data): Observable<any> {
    return this.patch(`/b2b-tickets/${ data.ticketNo }/agent-comment`, data);
  }

  forceRevert(data): Observable<any> {
    return this.patch(`/b2b-tickets/${ data.ticketNo }/force-revert`, data);
  }

  updateInteractionHistory(data: UpdateInteractionHistoryProps): Observable<any> {
    return this.patch(`/b2b-tickets/${ data.ticketNo }/update-interaction-history`, data);
  }

  requestSubmitTicket(data): Observable<any> {
    return this.patch(`/b2b-tickets/${ data.ticketNo }/request-submit/${ data.type }`, { frontend: data.frontend });
  }

  updateTrackingStatus(data): Observable<any> {
    return this.patch(`/b2b-tickets/${ data.ticketNo }/update-tracking-status`, data);
  }

  deleteTicketBosFile(params: any): Observable<any> {
    const { ticketNo } = params;
    return this.delete(`/b2b-tickets/file/${ ticketNo }`, { params });
  }

  deleteTicketFile(params: any): Observable<any> {
    const { ticketNo, attachmentId } = params;
    return this.delete(`/b2b-tickets/${ ticketNo }/attachments/${ attachmentId }`, { params });
  }

  getUserGuide(): Observable<any> {
    const url = `${ this.backend }/b2b-tickets/user-guide`;
    console.log('url =', url);
    return this.http.get(url, { responseType: 'arraybuffer' });
  }

  changePartnerOrganization(data): Observable<any> {
    const { ticketNo } = data;
    return this.patch(`/b2b-tickets/${ ticketNo }/partner-organization`, data);
  }
}
